export default __webpack_public_path__ + "static/partnerColorIcon8-4a33ba0ca22ed236af051097fcd6786d.svg";